import { COMUNI_ALL, COMUNE_COORDS as ALL_COORDS, COMUNE_INFO, REGIONI, PROVINCE_BY_REGIONE } from "./comuni-data";

export const GENERI = [
  "Romanzo", "Giallo e Thriller", "Fantasy", "Fantascienza", "Saggistica",
  "Storia", "Biografia", "Bambini e Ragazzi", "Fumetti", "Poesia",
  "Cucina", "Arte", "Scienze", "Altro",
];

export const CONDIZIONI = ["Come nuovo", "Buone condizioni", "Usato", "Molto vissuto"];

export { COMUNI_ALL, COMUNE_INFO, REGIONI, PROVINCE_BY_REGIONE };
export const COMUNI = COMUNI_ALL;

export const STATUS_LABELS = {
  available: "Disponibile",
  in_negotiation: "In trattativa",
  exchanged: "Scambiato",
  suspended: "Sospeso",
};

export const STATUS_BADGE = {
  available: "bg-emerald-100 text-emerald-800 border-emerald-300 dark:bg-emerald-950 dark:text-emerald-300 dark:border-emerald-800",
  in_negotiation: "bg-amber-100 text-amber-800 border-amber-300 dark:bg-amber-950 dark:text-amber-300 dark:border-amber-800",
  exchanged: "bg-stone-200 text-stone-700 border-stone-300 dark:bg-stone-800 dark:text-stone-400 dark:border-stone-700",
  suspended: "bg-stone-200 text-stone-700 border-stone-300 dark:bg-stone-800 dark:text-stone-400 dark:border-stone-700",
};

export const COMUNE_COORDS = ALL_COORDS;
